export const deDe = {
  global: {
    search: "Suchen",
    previous: "Vorherige",
    next: "Nächste",
    name: "Name",
    date: "Datum",
    layout: "Layout",
    quantity: "Quantität",
    entriesPerPage: "Einträge pro Seite",
    showFromToTotal: "Zeige {start} bis {end} von {total} Einträgen",
    requestError: "Anfrage für '{url}' ist fehlgeschlagen.",
    responseError: "Verarbeitung der Antwort von '{url}' ist fehlgeschlagen.",
    requestAuthorizationError: "Ungültige Authentifizierung der Anfrage an '{url}'. Bitte neu Anmelden.",
    responseParseError:
      "Verarbeitung der Antwort von '{url}' ist fehlgeschlagen. Die Struktur der Antwort stimmt nicht mit der erwarteten Struktur überein.",
    searchTimestamp: "Ab Startzeitpunkt suchen",
    description: "Beschreibung",
    noDescription: "Keine Beschreibung",
    language: "Sprache",
    theme: "Farbschema",
    settings: "Einstellungen",
    userInputs: "Benutzereingaben",
    documentation: "Dokumentation",
    error: "Ein Fehler ist aufgetreten",
    dateFormat: "DD.MM.YYYY",
    loadingSkipHint: "(Animation kann mit Linksklick versteckt werden)",
    skipEntryAnimation: "Ladeanimation verstecken",
    dates: {
      today: "Heute",
      yesterday: "Gestern",
      weekdays: {
        1: "Montag",
        2: "Dienstag",
        3: "Mittwoch",
        4: "Donnerstag",
        5: "Freitag",
        6: "Samstag",
        0: "Sonntag",
      },
      lastDay: "Letzten {day}",
      lastWeek: "Letzte Woche {day}",
      thisMonth: "Diesen Monat",
      lastMonth: "Letzten Monat",
      previousMonth: "Vorletzten Monat",
      longerTimer: "Vor längerer Zeit",
    },
    close: "Schließen"
  },
  app: {
    name: "Rittal externer Lieferantendruck",
    supplier: {
      info: {
        name: "Lieferant",
        list: "Lieferanten Liste",
        select: "Lieferant auswählen",
        sort: "Lieferanten nach Namen oder nach ID sortieren",
      },
      csvData: {
        tooltip: "CSV Daten des Lieferanten {supplier} herunterladen",
        loadingData: {
          success:
            "CSV Daten für Lieferant {supplier} erfolgreich heruntergeladen",
          failed:
            "Fehler beim herunterladen der CSV Daten für Lieferant {supplier}",
        },
      },
      loadingData: {
        info: "Lade Lieferanten",
        success: "Lieferanten erfolgreich geladen",
        error:
          "Beim Laden der Lieferanten ist ein Fehler aufgetreten. {message}",
        empty:
          "Keine Lieferanten für den Benutzer gefunden. (Anfrage war erfolgreich, aber Lieferanten-Liste aus der Antwort ist leer)",
      },
    },
    user: {
      info: {
        name: "Benutzer",
      },
      tooltip: {
        logout: "Abmelden",
      },
      loadingData: {
        info: "Authentifiziere Benutzer",
        success: "Benutzer authentifiziert",
        error:
          "Benutzer konnte nicht authentifiziert werden. Bitte die Seite neu laden. {message}",
        renewError:
          "Benutzer konnte im Hintergrund nicht authentifiziert werden. Bitte die Seite neu laden. {message}",
      },
    },
    system: {
      info: {
        name: "System",
        list: "System Liste",
      },
      tooltip: { select: "Das System zum Drucken auswählen" },
      loadingData: {
        info: "Lade Systeme",
        success: "Systeme erfolgreich geladen",
        error: "Fehler beim laden der Systeme. {message}",
        empty:
          "Keine Systeme für den Benutzer gefunden. (Anfrage war erfolgreich, aber die System-Liste aus der Antwort ist leer)",
      },
    },
    material: {
      info: {
        name: "Materialnummer",
        check: "Materialprüfung",
        removeCharacters:
          "Sonderzeichen wurden aus der Materialeingabe entfernt",
      },
      tooltip: {
        input: "Materialnummer eingeben",
      },
      loadingData: {
        info: "Prüfe Material",
        success: "Materialnummer ist gültig",
        error: "Überprüfung des Materials nicht möglich. {message}",
        invalid: "{material} ist keine gültige Materialnummer.",
        invalidShort: "Ungültige Materialnummer",
      },
    },
    printLabels: {
      info: {
        name: "Label Liste",
        labelPreview: "Label Vorschau",
        preview: "Vorschau",
        print: "Labels drucken",
        pieces: "Stückzahl",
        size: "Größe",
        label: "Label",
        downloadSelected: "Ausgewählte herunterladen",
        notReleasedInfo:
          "Nicht freigegeben (Das Feld 'Released' ist nicht gesetzt)",
      },
      tooltip: {
        preview: "Label Vorschau anzeigen",
        quantity: "Anzahl der Labels",
        csv: "Druckdaten als CSV herunterladen",
      },
      loadingData: {
        info: "Lade Label Liste",
        success: "Labels geladen",
        error: "Laden der Labels fehlgeschlagen. {message}",
        empty: "Keine Daten gefunden",
      },
      loadingPreview: {
        info: "Lade Label Vorschau",
        error: "Laden der Vorschau fehlgeschlagen. {message}",
        retry: "Erneut versuchen",
      },
      loadingDownload: {
        info: "Downloade Label",
        success: "Label {label} heruntergeladen",
        errorShort:
          "Generierungsdauer für {label} ({quantity} Stück) überschritten. PDF folgt in 'PDF-Historie'",
        error:
          "Die Generierungsdauer von {label} für {quantity} Stück wurde überschritten. Das PDF wird in der 'PDF-Historie' bereitgestellt, sobald die Generierung abgeschlossen ist.",
        errorHistoryLink: "Zur PDF-Historie",
      },
      loadingCsv: {
        error: "CSV download fehlgeschlagen. {message}",
      },
    },
    cancelSerials: {
      info: {
        name: "Seriennummer",
        nameFull: "Seriennummer stornieren",
        list: "Seriennummern Liste",
        cancel: "Stornieren",
        selectAll: "Alle Auswählen",
        searchTimestamp: "In Zeitraum suchen",
        search: "Seriennummer suchen",
        timeFormat: "TT.MM.JJJJ",
        type: "Typ",
      },
      loadingData: {
        info: "Suche Seriennummern",
        success: "Seriennummern geladen",
        error: "Laden der Seriennummern fehlgeschlagen. {message}",
        empty: "Keine Daten gefunden",
        limit:
          "Es wurden mehr als 4000 Nachrichten in der angegebenen Zeit gefunden. Ihnen werden nur die ersten 4000 Treffer angezeigt. Bitte grenzen Sie die Suchanfrage genauer ein. ",
      },
      loadingCancel: {
        info: "Storniere Seriennummern",
        success: "Seriennummern erfolgreich storniert",
        arrived: "Die Stornierung wurde erfolgreich übermittelt.",
        error: "Fehler beim stornieren der Seriennummern. {msg}",
      },
    },
    pdfHistory: {
      info: {
        name: "PDF Historie",
        generationLoadingTitle: "Label wird noch generiert",
        generationLoadingText: "Suche aktualisieren um Status zu aktualisieren",
      },
      tooltip: {
        download: "Label PDF herunterladen",
        newPdf: "Dies ist eine neue PDF",
      },
      loadingData: {
        info: "Lade PDF Historie",
        success: "PDF Historie geladen",
        error: "Fehler beim laden der PDF Historie. {message}",
        empty: "Keine PDFs gefunden",
      },
      loadingDownload: {
        error:
          "Fehler beim Download der PDF (Vermutlich wird das PDF noch generiert). Versuchen Sie es später noch einmal. {message}",
        success: "PDF {pdf} erfolgreich heruntergeladen.",
      },
    },
    documentation: {
      tooltip: "Hilfe öffnen",
      title: "App Dokumentation",
      keyPoints: "Hauptpunkte",
      print: {
        title: "Neue Labels generieren",
        text: `Im "Labels drucken"-Tab können Sie neue Etiketten generieren. Wählen Sie das Etikett aus, das Sie generieren möchten, und geben Sie die Anzahl der Kopien oder Serien ein, die Sie generieren möchten (Beachten Sie, dass die Anzahl der gleichzeitig generierten Etiketten auf 10.000 begrenzt ist).
        Wenn Sie Ihre Auswahl getroffen haben, klicken Sie auf die Schaltfläche "Herunterladen" rechts.
        
        Sobald der Download abgeschlossen ist, können Sie auf die neu generierte PDF-Datei zugreifen.
        
        Manchmal kann es vorkommen, dass die Generierungszeit den Anforderungszeitüberschreitung überschreitet. In diesem Fall erhalten Sie eine Benachrichtigung. Wenn die Generierung abgeschlossen ist, können Sie die generierte PDF-Datei im Tab "PDF-Verlauf" herunterladen.
        
        Sie können auch ein Etikett vor dem Generieren anzeigen. Klicken Sie dazu auf die Vorschau-Schaltfläche links neben jeder Zeile.`,
        keyPoints:
          'Gehen Sie zum Tab "Labels generieren",Geben Sie die gewünschte Anzahl der zu generierenden Etiketten an,Klicken Sie dann auf die Schaltfläche "Herunterladen"',
      },
      cancel: {
        title: "Generierte Seriennummern stornieren",
        text: `
        Im Tab "Seriennummern stornieren" können Sie generierte Seriennummern stornieren. Sie können die Anzahl der Seriennummern eingrenzen, indem Sie ein Startdatum angeben oder direkt nach einer bestimmten Seriennummer oder einem bestimmten Muster suchen.
        
        Sobald Sie Ihren Filter festgelegt haben, können Sie auf die Suchschaltfläche klicken, um die Seriennummern anzuzeigen, die Ihrem Filter entsprechen.
        Jetzt können Sie die Seriennummern auswählen, die storniert werden sollen. Wenn Sie Ihre Auswahl getroffen haben, klicken Sie auf die Stornierungsschaltfläche unten auf der Seite.
        
        Sobald der Stornierungsprozess abgeschlossen ist, sehen Sie eine Benachrichtigung, und die Seriennummernliste aktualisiert sich automatisch.
        
        Manchmal kann es vorkommen, dass die Generierungszeit den Anforderungszeitüberschreitung überschreitet. In diesem Fall erhalten Sie eine Benachrichtigung. Wenn die Generierung abgeschlossen ist, können Sie die generierte PDF-Datei im Tab "PDF-Verlauf" herunterladen.`,
        keyPoints:
          'Gehen Sie zum Tab "Seriennummern stornieren",(optional) Setzen Sie einen Filter um die angezeigten Seriennummern einzuschränken,Wählen Sie die Seriennummern aus die storniert werden sollen und klicken Sie dann auf die Schaltfläche "Stornieren"',
      },
      download: {
        title: "Zuvor generierte Labels herunterladen",
        text: `Im Tab "PDF-Verlauf" können Sie generierte Etiketten herunterladen. Sie können die Anzahl der PDFs eingrenzen, indem Sie ein Startdatum angeben.

        Sobald Sie Ihren Filter festgelegt haben, können Sie auf die Suchschaltfläche klicken, um die PDFs anzuzeigen, die Ihrem Filter entsprechen.
        Jetzt können Sie das Etikett herunterladen, indem Sie auf die Download-Schaltfläche rechts neben jeder Zeile klicken.
        
        Sobald der Download abgeschlossen ist, sehen Sie eine Benachrichtigung.
        
        Manchmal kann es vorkommen, dass das Etikett noch generiert wird und das PDF noch nicht verfügbar ist, aber bereits als Zeile angezeigt wird. Wenn das passiert, erhalten Sie eine Benachrichtigung. Sobald die Generierung abgeschlossen ist, können Sie das generierte PDF erfolgreich herunterladen.`,
        keyPoints: `Gehen Sie zum Tab "PDF-Verlauf", (optional) setzen Sie einen Datumsfilter um die angezeigten PDFs einzuschränken,Klicken Sie dann auf die Download-Schaltfläche für das Etikett das Sie herunterladen möchten.`,
      },
      logout: {
        title: "Abmelden",
        text: `Sie finden die Logout-Schaltfläche im Seitenmenü, das Sie in der oberen rechten Ecke öffnen können.

        Wenn das Menü geöffnet ist, befindet sich die Logout-Schaltfläche unten. Wenn Sie darauf klicken, werden Sie aufgefordert, Ihre Anmeldeinformationen einzugeben.`,
        keyPoints:
          "Öffnen Sie das Menü oben rechts,Klicken Sie auf die Logout-Schaltfläche unten.",
      },
      theme: {
        title: "Farbschema ändern (Dunkles/Helles Design)",
        text: `Sie finden die Farbeinstellungen im Seitenmenü, das Sie in der oberen rechten Ecke öffnen können.

        Wenn das Menü geöffnet ist, gibt es den Farbthemenumschalter. Wenn Sie darauf klicken, ändert die Anwendung das Farbthema.`,
        keyPoints:
          "Öffnen Sie das Menü oben rechts,Drücken Sie den Knopf zum ändern das Farbthema.",
      },
    },
  },
};
